var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-990"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.8,
    y: 111.09,
    width: 120.53,
    height: 212.72,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.5,162.68v-1.34H484.83V109.91H483.1v51.43H453V108.4h-6.73v52.94h-31V109.91h-1.73v51.43H388.67v1.34h24.79v51.41H388.67v6.73h24.79v53.52H388.67v1.34h24.79v48.1h1.73v-48.1h31v46.6H453v-46.6H483.1v48.1h1.73v-48.1H510.5v-1.34H484.83V220.82H510.5v-6.73H484.83V162.68Zm-95.31,0h31v51.41h-31Zm0,111.66V220.82h31v53.52Zm67.91,0H453V220.82H483.1Zm0-60.25H453V162.68H483.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.9 363.4 142.9 449.3 271.66 449.3 271.66 362.7 142.9 363.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 368.73,
    width: 119.03,
    height: 21.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 395.55,
    width: 119.03,
    height: 21.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 422.38,
    width: 119.03,
    height: 21.73,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 368.73,
    width: 36.9,
    height: 21.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.76,
    y: 395.55,
    width: 36.9,
    height: 21.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 422.23,
    width: 36.9,
    height: 21.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,362.7a8,8,0,0,1,0-5.92h34v5.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.54 357.67 164.54 361.81 198 361.35 198 357.67 164.54 357.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,356.78a8,8,0,0,1,0-5.93h34v5.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168 351.74 168 355.89 201.47 355.42 201.47 351.74 168 351.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,344.92c-.67-2.37-.83-4.15,0-7.78l34-1v8.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.91 338.92 167.01 343.84 199.65 343.31 199.65 337.69 166.91 338.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,350.85a8,8,0,0,1,0-5.93h34v5.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.09 346.27 165.09 349.31 198 349.49 198 345.81 165.09 346.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,337.07a7,7,0,0,1,0-5.94l33.47-.56a5.06,5.06,0,0,1,0,5.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.56 333.4 177.56 335.15 194.8 334.28 194.8 332.46 177.56 333.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,334.19a1.05,1.05,0,1,1-1-1.05A1,1,0,0,1,175.7,334.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.78 390.46 233.41 372.4 246.17 390.46 221.78 390.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.41 372.4 233.97 390.46 221.78 390.46 233.41 372.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.2 390.46 254.15 383.6 260.04 390.46 249.2 390.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.15 383.6 254.62 390.46 249.2 390.46 254.15 383.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.69 344.39 229.69 362.86 247.49 362.86 246.82 344.39 230.69 344.39",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,339.06s-5.6-.09-5.86-4.42C231.59,334.64,236.43,332.43,237.45,339.06Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.81,326.66s-2.12,4.07,3,5.77C234.78,332.43,236,327.08,231.81,326.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,333.37s-.38,4.27,5.56,4.63C231.26,338,231.26,332.64,225.7,333.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,334.9a3,3,0,0,1,2.64-4.17S242.15,334.1,238,334.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,336.52s-.34-3.23,3.65-3.74C247.85,332.78,248.19,335.5,244.2,336.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.22,338.21s-5.79-1.55-8.12,2c0,0,3.58,2.43,7.29,1.5l3.56-2.63s2.28-3.63,1.51-5C242.46,334.1,237.78,335.66,238.22,338.21Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,341.65s4.55-.17,4-5.2A4.71,4.71,0,0,0,247.19,341.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,337.63s3.83.45,4.53,1.78c0,0-2.44,4.28-7.18.74C239.3,340.15,238.36,337.67,242,337.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.39,341.69l-3.37-.14-.24,2.85h9.94L246,343s.46-1.31-3.92-1.42l-1.56-2h-2.71Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,342.54S233.4,338,229,341.6C229,341.6,232.72,346.36,237.22,342.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.67,341c.06.33-5,1.29-5.45-3.45C237.22,337.54,241.63,335.5,242.67,341Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,413h0a4,4,0,0,1,3.86-3.81l31.47-.73v8.64H173.72A4,4,0,0,1,169.76,413Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,410.84a4.64,4.64,0,0,0,0,4.74h32.14V409.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,405.28h0a3.07,3.07,0,0,1,3-3l24.52-.59v6.74l-24.46,0A3.09,3.09,0,0,1,177.65,405.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.13,403.66a3.64,3.64,0,0,0,0,3.7l25,0v-4.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.23 397.4 205.16 417.23 209.3 417.28 209.3 397.4 205.23 397.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.01 400.15 213.9 417.23 220.31 417.28 220.31 400.15 214.01 400.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.39 400.15 209.35 417.23 211.42 417.28 211.42 400.15 209.39 400.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.35 400.15 220.31 417.23 222.38 417.28 222.38 400.15 220.35 400.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.11 397.4 211.06 417.23 213.89 417.28 213.89 397.4 211.11 397.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.52 397.4 222.47 417.23 225.29 417.28 225.29 397.4 222.52 397.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,417h-9.66l0,0-7-6.95.08-.08,7-7h0l7.09-.53,0,0,7.83,6.16Zm-9.55-.25h9.41l5.16-8.07-7.61-6-7,.52-6.79,6.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.85 416.97 237.46 409.37 237.49 409.3 240.85 402.91 242.92 404.94 246.18 404.94 247.94 402.36 251.94 408.67 251.9 408.73 247.78 416.95 247.55 416.84 251.65 408.68 247.93 402.82 246.31 405.19 242.82 405.19 242.78 405.15 240.92 403.33 237.75 409.35 243.05 416.83 242.85 416.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.99 410.17 233.96 409.92 241.52 408.87 249.47 408.55 255.68 408.55 255.68 408.8 249.47 408.8 241.54 409.12 233.99 410.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.84 416.94 241.4 408.99 241.42 408.95 242.75 405.03 242.99 405.11 241.67 409 244.08 416.86 243.84 416.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246 416.93 245.76 416.86 248.14 408.69 246.14 405.13 246.36 405 248.41 408.66 248.4 408.71 246 416.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.79,
    y: 154.65,
    width: 42.32,
    height: 53.42,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.28,
    y: 206.88,
    width: 5.87,
    height: 1.42,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.3 173.04 579.5 174.19 576.6 181.51 581.48 187.69 589.27 186.55 592.18 179.22 587.3 173.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.94 177.78 583.15 178.92 580.24 186.24 585.12 192.42 592.92 191.28 595.83 183.96 590.94 177.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.11,
    y: 153.93,
    width: 5.87,
    height: 1.22,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.86,
    y: 213.93,
    width: 25.38,
    height: 32.05,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.95,
    y: 245.26,
    width: 3.52,
    height: 0.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.36 224.96 177.69 225.65 175.94 230.04 178.87 233.74 183.55 233.06 185.29 228.67 182.36 224.96",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.55 227.8 179.87 228.48 178.13 232.88 181.06 236.58 185.73 235.9 187.48 231.51 184.55 227.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.45,
    y: 213.49,
    width: 3.52,
    height: 0.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294 145.65 302.92 168.46 297.38 168.43 292.93 154.41 294 145.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.56 124.57 260.49 168.27 292.13 168.94 295.69 124.57 263.56 124.57",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.72 128.09 264.17 164.47 287.69 165.57 290.98 127.88 266.72 128.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.88 133.23 269.98 158.81 282.95 158.81 285.24 133.23 271.88 133.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.57 168.62 216.57 132.68 242.89 132.68 242.89 168.59 216.57 168.62",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,132.68s6.35-46.39,4.57-46.33-6.24,42.3-6.24,42.3-.19-35-1.86-34.79,0,37,0,37-2.86-29.9-4.41-29.19.66,31,.66,31h7.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.75,132.68s2.2-23.12,2.92-21.54,0,13.77,0,13.77S235.77,95,237.36,96s-6.24,32.43-6.24,32.43,5.95-17.93,7.26-16-4.93,18.71-4.93,18.71,6.38-11.89,6.81-10.3-3,11.84-3,11.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,132.82s-14.07-27.62-12.33-26.76,10.73,18.7,10.73,18.7-6-17.23-4.64-17.75,7.83,19.34,7.83,19.34l1.47,6.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.75 132.74 229.42 168.68 216.91 168.68 216.66 132.62 228.75 132.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.6 135.85 228.72 136.06 242.89 135.85 243.33 132.42 216.26 132.42 216.6 135.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.4,
    y: 168.03,
    width: 112.18,
    height: 5.78,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.94,449.76c0,.15-125.79.27-280.93.27s-280.95-.12-280.95-.27,125.76-.27,281-.27S655.94,449.61,655.94,449.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.72,349.56c-4.3.69-6.22,6-5.85,10.32s2.17,8.59,1.69,12.92c-.61,5.5-4.76,10.15-5.25,15.66-.57,6.5,4,12.27,5.4,18.65.67,3.1.57,6.38,1.73,9.34a11.68,11.68,0,0,0,22.56-4c.09-5-3-9.69-2.61-14.67.28-3.68,2.43-7.17,2-10.83-.55-4.36-4.59-7.45-6-11.6s-.06-8.74-.55-13.1c-.88-7.83-5.22-13.29-13.08-12.66",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.72,349.56c-4.3.69-6.22,6-5.85,10.32s2.17,8.59,1.69,12.92c-.61,5.5-4.76,10.15-5.25,15.66-.57,6.5,4,12.27,5.4,18.65.67,3.1.57,6.38,1.73,9.34a11.68,11.68,0,0,0,22.56-4c.09-5-3-9.69-2.61-14.67.28-3.68,2.43-7.17,2-10.83-.55-4.36-4.59-7.45-6-11.6s-.06-8.74-.55-13.1c-.88-7.83-5.22-13.29-13.08-12.66",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M505.76,387.47c-.74,7.26,2.47,15.79,6.2,22.06a34.61,34.61,0,0,0,16.24,14.09,1.79,1.79,0,0,0,2.94-1.79,35.62,35.62,0,0,0-25.38-34.36",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.36,438.79a1.58,1.58,0,0,1-.21-.4c-.13-.31-.31-.71-.52-1.19-.43-1-1.08-2.53-1.91-4.36a156,156,0,0,0-7.21-13.94,151.51,151.51,0,0,0-8.61-13.12c-1.19-1.63-2.17-2.93-2.86-3.82-.32-.41-.57-.76-.78-1a2.22,2.22,0,0,1-.25-.38,2,2,0,0,1,.31.33l.85,1c.73.86,1.74,2.14,3,3.74A131.57,131.57,0,0,1,535,432.72c.8,1.85,1.41,3.36,1.8,4.42l.45,1.22A2.09,2.09,0,0,1,537.36,438.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.69,369.63a5.61,5.61,0,0,1,.08.7c0,.49.08,1.16.14,2,.12,1.77.28,4.27.47,7.35.4,6.2,1,14.78,1.61,24.25s1.33,18,1.81,24.23c.23,3.08.42,5.58.56,7.35.06.84.1,1.5.14,2a3.78,3.78,0,0,1,0,.7s0-.24-.1-.7-.12-1.15-.21-2c-.17-1.77-.4-4.26-.69-7.33-.56-6.2-1.26-14.76-1.93-24.24s-1.17-18-1.49-24.26c-.14-3.08-.26-5.58-.34-7.36,0-.84,0-1.5-.07-2A3.4,3.4,0,0,1,532.69,369.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,428.45h18.17v13.34a8.72,8.72,0,0,1-8.72,8.72h0a8.73,8.73,0,0,1-8.71-8.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.59,205.67h0a8.55,8.55,0,0,0,9.21-8.19c.18-4.65.34-9.36.34-9.36s7.05-.65,7.57-7.63.3-23.1.3-23.1h0A24.34,24.34,0,0,0,375.42,159l-1.08.74.36,37.54A8.56,8.56,0,0,0,382.59,205.67Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.68,169.67a1,1,0,0,1,0-1.43,1,1,0,1,1,0,1.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.4,168.5c-.12.11-.77-.46-1.73-.52s-1.69.39-1.79.26.07-.27.39-.49a2.31,2.31,0,0,1,1.44-.35,2.35,2.35,0,0,1,1.37.56C399.36,168.22,399.45,168.45,399.4,168.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.56,168.35a1,1,0,0,1,.24,1.42,1,1,0,0,1-1.66-1.17A1,1,0,0,1,387.56,168.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.9,168.71c-.12.11-.77-.46-1.73-.52s-1.69.39-1.79.26.07-.27.39-.48a2.4,2.4,0,0,1,1.44-.36,2.26,2.26,0,0,1,1.37.57C388.87,168.43,389,168.66,388.9,168.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.32,176.18a4.71,4.71,0,0,1,1.57-.23c.25,0,.46-.06.48-.19a1.3,1.3,0,0,0-.13-.73l-.64-2a26.4,26.4,0,0,1-1.33-5.24,27,27,0,0,1,1.85,5.07c.21.7.4,1.36.6,2a1.6,1.6,0,0,1,.07,1.05.64.64,0,0,1-.46.38,1.69,1.69,0,0,1-.43,0A4.52,4.52,0,0,1,392.32,176.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,177.05c.58.26,2.67,1.64,4.64,1.67a2.68,2.68,0,0,1-3.21.86C388.51,178.69,389.12,177.05,389.12,177.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.16,188a16.25,16.25,0,0,1-9-3.15s1.84,5.16,8.85,5Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.73,168.32a1.06,1.06,0,0,0-1-1.06c-1.31,0-3.44.48-3.64,4.08-.28,5.14,4.66,3.85,4.68,3.71S374.74,170.31,374.73,168.32Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.62,173s-.09.06-.24.12a.88.88,0,0,1-.67,0,2.19,2.19,0,0,1-.92-2,3,3,0,0,1,.32-1.27,1.06,1.06,0,0,1,.71-.65.46.46,0,0,1,.52.28c.06.14,0,.24.05.25s.11-.07.08-.29a.5.5,0,0,0-.18-.33.68.68,0,0,0-.49-.16,1.26,1.26,0,0,0-1,.74,3.22,3.22,0,0,0-.39,1.42,2.32,2.32,0,0,0,1.19,2.29,1,1,0,0,0,.82-.09C373.61,173.15,373.64,173,373.62,173Z",
    style: {
      fill: "#a36957"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.52,155.54a31.88,31.88,0,0,0-17.91-1.15s-6,2.09-6.27,5.3a54.93,54.93,0,0,0,.08,7.88l.37,0,.06,5.38H377l.31-7.27s4.11-2.84,4.19-7.26c2-.27,11.84-1.42,18.54.87v-1.56A2.36,2.36,0,0,0,398.52,155.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,421.57l9-3.91-7.22-16.87-13.2,5.59.38,1.07c1.74,4.77,9.16,24.11,11.44,26.81C315.89,437.28,313,421.57,313,421.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28,412.44a6.41,6.41,0,0,0,2.68-3.69,6.18,6.18,0,0,0-.47-4.47l-4.71,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,429.35s.7,5.65-.39,5.37-9.34-19.53-12.23-28.34l.39-.13,9.42,22.54S313.69,428.39,314.15,429.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.82,406a1.26,1.26,0,0,0,.09.3l.3.85c.33.85.72,1.9,1.18,3.13,1,2.63,2.47,6.24,4.16,10.19s3.29,7.51,4.49,10.06l1.44,3,.4.81a1.64,1.64,0,0,0,.16.28,1.18,1.18,0,0,0-.12-.3c-.11-.25-.23-.52-.36-.83-.38-.82-.84-1.84-1.38-3-1.16-2.56-2.74-6.12-4.43-10.07s-3.16-7.56-4.21-10.17c-.49-1.22-.91-2.26-1.24-3.1-.13-.31-.25-.58-.35-.84A2,2,0,0,0,301.82,406Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.07,428.9a7.73,7.73,0,0,1,1.71,0,7.58,7.58,0,0,1,1.62.54,2.46,2.46,0,0,0-1.59-.76A2.43,2.43,0,0,0,311.07,428.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.47,422.84a3.54,3.54,0,0,0,1.78.29,2,2,0,0,0-.87-.25A2,2,0,0,0,311.47,422.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.61,421.17c0,.05.26.24.65.42s.72.28.74.23-.26-.25-.65-.43S311.63,421.11,311.61,421.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,419.62c-.06,0,.06.44.26.93s.42.87.47.84a2.07,2.07,0,0,0-.26-.92C313.1,420,312.89,419.6,312.83,419.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.83,418.85A1.84,1.84,0,0,0,314,420a1.89,1.89,0,0,0,.57,1,6.12,6.12,0,0,0-.36-1A6,6,0,0,0,313.83,418.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.19,422.79a3.25,3.25,0,0,0,.47,1.08,7.61,7.61,0,0,0,.74,1,3.66,3.66,0,0,0,.56.55.66.66,0,0,0,.45.12.46.46,0,0,0,.36-.35,2.15,2.15,0,0,0-1.63-2.21,2,2,0,0,0-.87,0,.69.69,0,0,0-.31.09,3.5,3.5,0,0,1,1.14.1,2.11,2.11,0,0,1,1,.67,1.8,1.8,0,0,1,.47,1.33c-.05.23-.29.25-.48.1a4,4,0,0,1-.52-.49,8.2,8.2,0,0,1-.77-1C313.4,423.18,313.22,422.77,313.19,422.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.25,423.09a1.18,1.18,0,0,0,.81-.2,2,2,0,0,0,.66-.63,1.18,1.18,0,0,0,.17-1.14.46.46,0,0,0-.64-.12,1.28,1.28,0,0,0-.41.39,4,4,0,0,0-.44.79,1.87,1.87,0,0,0-.17.81s.1-.3.32-.74a4.07,4.07,0,0,1,.45-.74c.17-.24.54-.52.7-.27s0,.65-.15.91a2.11,2.11,0,0,1-.57.61A4.69,4.69,0,0,1,313.25,423.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.58,404.35s.25.46.49,1.26a5.88,5.88,0,0,1,0,3.2,6,6,0,0,1-1.67,2.73c-.62.56-1.09.8-1.07.83a1,1,0,0,0,.34-.14,5.38,5.38,0,0,0,.83-.58,5.6,5.6,0,0,0,1.68-6.09,5,5,0,0,0-.42-.91C306.67,404.44,306.59,404.34,306.58,404.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.35,403.09a31.91,31.91,0,0,0-3.53,1.34,29.15,29.15,0,0,0-3.44,1.54,67.26,67.26,0,0,0,7-2.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,413.86a10.19,10.19,0,0,0,.8,2.56,10.72,10.72,0,0,0,1.26,2.39c.05,0-.48-1.11-1-2.47S306.9,413.84,306.84,413.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.43,410.55c-.06,0-.2.19-.4.41s-.41.38-.38.43.31,0,.54-.28S305.48,410.57,305.43,410.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.44,408.64c-.05,0-.18.16-.28.41s-.14.47-.09.5.19-.16.29-.42S306.5,408.66,306.44,408.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,406.55c-.05,0,.05.26.06.55s0,.52,0,.55.23-.22.21-.57S306.43,406.51,306.39,406.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,405.14c-.06,0-.11.14-.1.3s.06.29.12.29.11-.13.1-.3S306.24,405.14,306.18,405.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.47,444.63l1-9.75-18.24-2-1.6,14.24,1.12.19c5,.83,25.5,3.84,29,3.18C443.59,449.79,428.47,444.63,428.47,444.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25,447.72a6.38,6.38,0,0,0-1.91-4.14,6.19,6.19,0,0,0-4.12-1.79l-.56,5.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.83,447.42s5.26,2.15,4.48,3-21.6-1.45-30.69-3.25l.07-.41L434,449.59S434.76,447.35,435.83,447.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.4,446.7l.31.07.9.15,3.3.5c2.79.41,6.65.92,10.92,1.39s8.16.81,11,1l3.33.23.9,0a1.3,1.3,0,0,0,.32,0l-.31,0-.91-.09-3.32-.29c-2.8-.25-6.68-.62-10.95-1.08s-8.14-1-10.93-1.32l-3.31-.44-.9-.11A1.53,1.53,0,0,0,409.4,446.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.92,449.88a8.09,8.09,0,0,1,.79-1.52,7.71,7.71,0,0,1,1.27-1.14,2.4,2.4,0,0,0-1.44,1A2.49,2.49,0,0,0,433.92,449.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.84,446.56c.05,0,.34-.25.65-.64s.52-.73.48-.77-.34.24-.66.63S428.79,446.52,428.84,446.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.45,445.62c0,.05.34-.11.68-.36s.6-.49.56-.54-.34.11-.68.36S427.41,445.57,427.45,445.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7,443.8a2.14,2.14,0,0,0,.94.22c.52.06,1,.07,1,0a2.14,2.14,0,0,0-.94-.22C427.14,443.74,426.71,443.73,426.7,443.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.51,442.55a1.88,1.88,0,0,0,1,.42,1.78,1.78,0,0,0,1.11,0,6.35,6.35,0,0,0-1.07-.19A6,6,0,0,0,426.51,442.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.63,445a3.45,3.45,0,0,0,1.17.12,8.15,8.15,0,0,0,1.28-.14,3.47,3.47,0,0,0,.75-.22.66.66,0,0,0,.33-.33A.49.49,0,0,0,433,444a2.17,2.17,0,0,0-2.73.34,2.1,2.1,0,0,0-.46.74.75.75,0,0,0-.07.31,3.41,3.41,0,0,1,.64-.94,2.13,2.13,0,0,1,1.07-.54,1.8,1.8,0,0,1,1.39.25c.17.16.08.37-.14.47a4.22,4.22,0,0,1-.69.21,8.23,8.23,0,0,1-1.24.18C430.08,445.05,429.63,445,429.63,445Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.93,445.13a1.22,1.22,0,0,0,.22-.8,1.87,1.87,0,0,0-.23-.89,1.2,1.2,0,0,0-.91-.71.48.48,0,0,0-.42.51,1.3,1.3,0,0,0,.14.54,4.11,4.11,0,0,0,.48.77c.33.4.6.57.62.55s-.21-.24-.49-.64a4.8,4.8,0,0,1-.42-.76c-.13-.27-.19-.72.11-.74s.56.32.71.58a1.89,1.89,0,0,1,.25.8A4.88,4.88,0,0,1,429.93,445.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.32,441.75s.53,0,1.34.19a5.76,5.76,0,0,1,4.36,4.33c.2.81.17,1.34.21,1.34a1.38,1.38,0,0,0,0-.37,4.54,4.54,0,0,0-.09-1,5.57,5.57,0,0,0-4.49-4.45,4.38,4.38,0,0,0-1-.08A1,1,0,0,0,410.32,441.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,434.37a31.17,31.17,0,0,0-.57,3.72,29.62,29.62,0,0,0-.34,3.76,32.51,32.51,0,0,0,.56-3.73A33.45,33.45,0,0,0,413,434.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,446.19a15.36,15.36,0,0,0,5.33.63c0-.06-1.2-.12-2.67-.3S418.75,446.13,418.73,446.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.16,445.8c-.05,0,.07.26.16.55s.13.53.2.53.12-.27,0-.6S415.2,445.76,415.16,445.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,444c-.05,0,0,.24.21.46s.35.35.39.31-.05-.24-.21-.45S414,443.94,414,444Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.15,443c0,.06.25.08.51.21s.43.29.48.25-.07-.31-.39-.45S412.14,442.94,412.15,443Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.82,442.49c0,.05.06.16.21.23s.28.09.31,0-.06-.16-.21-.24S410.85,442.43,410.82,442.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,297s-1.87,37.38-7.84,56.7-21.41,23.85-31.44,30c-9.58,5.85-31,16.88-31,16.88l11.75,20.93s59-24.11,69.71-46.21C394.78,358.29,404,327,404,327Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,280.67s24.12,52.14,30.56,66.29a10,10,0,0,1,.87,4.73L434.49,439l-25.09-1.58,3.76-84.22-41.92-53.88a39.13,39.13,0,0,1-7.44-15.57,24.82,24.82,0,0,1-.64-5.66h0l45.34,2.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,175.12c-1.39-.51-4.34,7-4.64,5s4.68-8.73,3.2-9.21c-1.92-.61-4.87,7.28-5.17,7.93s-1.25.24-.94-.33c.43-.83,4.76-9.57,2.88-10.19-1.05-.35-1.49,1.59-1.49,1.59s-3.45,8.48-4.33,8.15,1-5.37,1.71-7,.26-2.65-.73-2.38c-.68.19-3.09,5.21-3.79,6.87s-2.54,6.23-3.47,3.24-2.77-4.95-3.64-5.13a1,1,0,0,0-.78,1.68,11.21,11.21,0,0,1,1.49,2.79,7.22,7.22,0,0,1,.56,2.47,26.24,26.24,0,0,1-.15,5.11L440,216.48,412.5,205.7l-4,15.75s36.13,16.45,38.42,15.24c5.16-2.72,21.83-47.64,21.83-47.64h0a107.56,107.56,0,0,0,6.78-9.47C477.84,175.52,477.48,175.31,477,175.12Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.22,211.35c-7.64-3.93-13.05-6.26-17.22-8.94-13-8.32-16.38-6.48-19.43-6.86-2.56.79-6.36,2.28-7.79,2.55s-6.69-1.51-10.08-2.56h0c-7.89.34-12.73,3.69-20,9.06l-11.92,10,15.07,15.17,5.05-2.61c.85,6.83.64,9.5.95,17.75l-.67,33.16,49.06,2.78-2.7-31.75-1.19-25,14,7,6.91-19.78",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.22,211.35c-7.64-3.93-13.05-6.26-17.22-8.94-13-8.32-16.38-6.48-19.43-6.86-2.56.79-6.36,2.28-7.79,2.55s-6.69-1.51-10.08-2.56h0c-7.89.34-12.73,3.69-20,9.06l-11.92,10,15.07,15.17,5.05-2.61c.85,6.83.64,9.5.95,17.75l-.67,33.16,49.06,2.78-2.7-31.75-1.19-25,14,7,6.91-19.78"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.34,196.47v-5.09s8.75.92,10.53,7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.57,195.55l-.33-4.17a8.61,8.61,0,0,0-7.37,7Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "342.76 214.63 357.83 229.8 359.53 228.92 343.84 213.72 342.72 214.63",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.01 210.73 420.62 230.28 422.31 231.13 429.78 211.67 428.01 210.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.61 214.37 393.61 220.8 397.06 222.99 400.05 220.93 400.05 214.37 393.61 214.37",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89,216a9.92,9.92,0,0,1-3.2.22,10.09,10.09,0,0,1-3.2-.3,9.56,9.56,0,0,1,3.2-.22A10.15,10.15,0,0,1,399.89,216Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.89,216a9.92,9.92,0,0,1-3.2.22,10.09,10.09,0,0,1-3.2-.3,9.56,9.56,0,0,1,3.2-.22A10.15,10.15,0,0,1,399.89,216Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.58,208.19a21.4,21.4,0,0,1-.26-4.75,21.53,21.53,0,0,1,.26-4.76,22.28,22.28,0,0,1,.26,4.76A22.15,22.15,0,0,1,384.58,208.19Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,200c0-.06.22-.18.5.06a.65.65,0,0,1,.2.58.68.68,0,0,1-.57.55.7.7,0,0,1-.73-.33.67.67,0,0,1,0-.62c.18-.31.45-.28.45-.22s-.09.17-.11.35.07.34.29.31.25-.2.17-.38S386.44,200,386.43,200Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.05,203.78c0-.07.28-.07.44.25a.69.69,0,0,1,0,.61.73.73,0,1,1-1.28-.68c.2-.3.46-.27.46-.21s-.09.17-.12.36,0,.37.28.39.33-.15.32-.36S387,203.84,387.05,203.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,361.61l-24.64-79.26A18.08,18.08,0,0,1,258,259.72l198.69-61.85a18.08,18.08,0,0,1,22.64,11.89L503.93,289A18.09,18.09,0,0,1,492,311.66L293.35,373.51A18.09,18.09,0,0,1,270.71,361.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.87,291.13l-4.77-15.37a4,4,0,0,0-5.06-2.51l-2.79.86a4,4,0,0,1-5.06-2.51l-9.31-30a4,4,0,0,1,2.74-4.94l2.79-.87a4,4,0,0,0,2.74-5l-1.68-5.4L472.28,212a12.65,12.65,0,0,0-15.85-8.33L262.5,264.07a12.65,12.65,0,0,0-8.33,15.84L278.76,359a12.66,12.66,0,0,0,15.85,8.33L488.55,307A12.66,12.66,0,0,0,496.87,291.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,242.69a3.48,3.48,0,0,1-.19.61l-.62,1.71,0,.1-.09,0-4.13-1.76.21-.07c-1.21,2.33-2.7,5.2-4.38,8.46l-.11-.3,3.87,1.8.17.08,0,.17a12.77,12.77,0,0,1-.87,3.06,5.67,5.67,0,0,1-2.06,2.64,3,3,0,0,1-.83.34l-.44.11H420a2.94,2.94,0,0,1-.89-.12,3.51,3.51,0,0,1-.85-.27,5.36,5.36,0,0,1-2.69-2.35,5.92,5.92,0,0,1-.69-3.51,6.71,6.71,0,0,1,.43-1.71c.22-.55.5-1,.75-1.52,1-2,2-3.85,2.93-5.65s1.83-3.51,2.66-5.12a19.79,19.79,0,0,1,1.3-2.3,3.25,3.25,0,0,1,2.15-1.26,4.73,4.73,0,0,1,3.9,1.43,5.09,5.09,0,0,1,1.37,2.84,4.89,4.89,0,0,1-.13,2,3.29,3.29,0,0,1-.17.49c0,.11-.08.16-.08.15a6.16,6.16,0,0,0,.18-2.6,4.94,4.94,0,0,0-1.38-2.66,4.42,4.42,0,0,0-3.64-1.28,2.9,2.9,0,0,0-1.88,1.14,19.09,19.09,0,0,0-1.23,2.26l-2.62,5.14-2.91,5.67a7.91,7.91,0,0,0-1.11,3,5.25,5.25,0,0,0,.63,3.19,4.88,4.88,0,0,0,2.43,2.14,3.33,3.33,0,0,0,3,0,5.18,5.18,0,0,0,1.87-2.4,12.23,12.23,0,0,0,.84-2.92l.14.24-3.86-1.83-.21-.1.11-.2,4.5-8.41.07-.13.13.06,4.08,1.87-.13.05.71-1.68A3.15,3.15,0,0,1,430,242.69Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.83,263s.14.4.55,1.08a5.37,5.37,0,0,0,5,2.53,14.23,14.23,0,0,0,2.86-.79l7-2.27,8.44-2.74,2.31-.75a9.24,9.24,0,0,0,2.27-.92A5.16,5.16,0,0,0,441.6,255a6.78,6.78,0,0,0-.52-2.57l-.85-2.66c-.58-1.78-1.16-3.61-1.76-5.46l-3.69-11.51a5.18,5.18,0,0,0-4.26-3.53,5.9,5.9,0,0,0-2.83.4l-2.81.9L414.16,234l-5,1.59a12.57,12.57,0,0,0-2.31.85,5.23,5.23,0,0,0-1.71,1.56,5.15,5.15,0,0,0-.77,4.23c.41,1.4.86,2.76,1.26,4.05l3.85,12.26c.43,1.43.77,2.54,1,3.34.1.36.19.65.25.87a1.58,1.58,0,0,1,.07.31,1.48,1.48,0,0,1-.12-.29c-.08-.22-.18-.5-.3-.86-.27-.79-.64-1.9-1.11-3.31-1-2.91-2.32-7.08-4-12.21-.41-1.29-.87-2.62-1.3-4.06a5.63,5.63,0,0,1,.8-4.58,5.7,5.7,0,0,1,1.85-1.7,13.3,13.3,0,0,1,2.39-.9l5-1.61,10.72-3.45,2.81-.9a6.25,6.25,0,0,1,3-.42,5.67,5.67,0,0,1,4.68,3.88c1.26,3.95,2.5,7.79,3.69,11.51l1.74,5.47.85,2.66a7.21,7.21,0,0,1,.53,2.73,5.65,5.65,0,0,1-2.61,4.57,9.48,9.48,0,0,1-2.37.95l-2.32.74-8.46,2.68-7,2.2a14.2,14.2,0,0,1-2.93.75,5.41,5.41,0,0,1-5.12-2.72A4,4,0,0,1,410.83,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,304.05s.14.4.55,1.08a5.41,5.41,0,0,0,2.59,2.17,5.26,5.26,0,0,0,2.43.35,14.26,14.26,0,0,0,2.85-.78l7-2.28,8.44-2.73,2.32-.75a9.4,9.4,0,0,0,2.26-.92,5.17,5.17,0,0,0,2.37-4.19,6.85,6.85,0,0,0-.51-2.58l-.86-2.65-1.76-5.47c-1.19-3.71-2.43-7.56-3.69-11.5a5.16,5.16,0,0,0-4.25-3.53,5.89,5.89,0,0,0-2.83.4l-2.81.9L427.31,275l-5,1.59a12.84,12.84,0,0,0-2.31.85,5.2,5.2,0,0,0-2.48,5.79c.41,1.39.87,2.76,1.27,4l3.84,12.26c.44,1.42.78,2.54,1,3.34l.25.87a1,1,0,0,1,.07.31,1.48,1.48,0,0,1-.12-.29c-.07-.22-.17-.5-.3-.86-.26-.79-.64-1.9-1.11-3.31-1-2.92-2.32-7.08-4-12.21-.42-1.3-.87-2.62-1.31-4.06a5.6,5.6,0,0,1,.81-4.58,5.77,5.77,0,0,1,1.84-1.7,13.59,13.59,0,0,1,2.39-.9l5-1.61,10.71-3.45,2.81-.9a6.27,6.27,0,0,1,3.05-.42,5.68,5.68,0,0,1,4.69,3.88l3.68,11.51c.59,1.86,1.18,3.68,1.75,5.47.28.9.56,1.78.84,2.65a7.26,7.26,0,0,1,.53,2.74,5.63,5.63,0,0,1-2.6,4.56,9.21,9.21,0,0,1-2.38,1l-2.32.74L439.48,305l-7,2.19a14.09,14.09,0,0,1-2.93.76,5.53,5.53,0,0,1-2.51-.41,5.37,5.37,0,0,1-2.61-2.31A4,4,0,0,1,424,304.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.4,299.4a20.09,20.09,0,0,0,2.36-1.21,10.76,10.76,0,0,0,4.34-5.53,10.58,10.58,0,0,0-1.65-10,10.68,10.68,0,0,0-5-3.54,10.49,10.49,0,0,0-11.87,3.81,10.42,10.42,0,0,0-2,5.78,10.66,10.66,0,0,0,11.21,11.06,21.36,21.36,0,0,0,2.62-.38,8.53,8.53,0,0,1-2.6.59,10.8,10.8,0,0,1-7-1.88,11,11,0,0,1-3.4-3.75,11.12,11.12,0,0,1-1.33-5.66,10.37,10.37,0,0,1,.56-3.12,10.55,10.55,0,0,1,1.52-2.94,11,11,0,0,1,12.44-4,11,11,0,0,1,5.22,3.72,10.93,10.93,0,0,1,1.62,10.41,10.79,10.79,0,0,1-4.59,5.58A8.46,8.46,0,0,1,439.4,299.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,299.24c-.14,0-1.75-4.6-3.6-10.38s-3.24-10.49-3.11-10.53,1.75,4.6,3.61,10.37S440.26,299.2,440.12,299.24Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,292.77a1.73,1.73,0,0,1,.48,0l1.37.21a18.49,18.49,0,0,0,2.15.29,24.94,24.94,0,0,0,2.87.14,17.1,17.1,0,0,0,7.27-1.39,12.94,12.94,0,0,0,3.57-2.51,10.41,10.41,0,0,0,2.43-3.95l.1.28c-.17-.12-.39-.24-.59-.36a15.86,15.86,0,0,0-9-2.23,10.89,10.89,0,0,0-6.78,3.15,17.84,17.84,0,0,0-3.13,4.14,16.68,16.68,0,0,1-.94,1.68,2.74,2.74,0,0,1,.17-.47c.14-.3.3-.76.6-1.3a16.36,16.36,0,0,1,3-4.31,11.22,11.22,0,0,1,7-3.37,16.21,16.21,0,0,1,9.28,2.26l.62.38.17.11-.06.17a10.68,10.68,0,0,1-2.57,4.18,13.09,13.09,0,0,1-3.73,2.58,17.11,17.11,0,0,1-7.47,1.33,21.88,21.88,0,0,1-2.9-.23,16.76,16.76,0,0,1-2.16-.37l-1.35-.31A1.53,1.53,0,0,1,426,292.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.42,302.16s.14.4.55,1.08a5.46,5.46,0,0,0,2.59,2.17,5.26,5.26,0,0,0,2.43.35,14.34,14.34,0,0,0,2.86-.78l7-2.28,8.43-2.73,2.32-.75a9.4,9.4,0,0,0,2.26-.92,5.17,5.17,0,0,0,2.37-4.19,6.85,6.85,0,0,0-.51-2.58l-.86-2.65-1.76-5.47c-1.19-3.71-2.42-7.56-3.69-11.5a5.16,5.16,0,0,0-4.25-3.53,5.89,5.89,0,0,0-2.83.4l-2.81.9-10.73,3.42-5,1.59a13.64,13.64,0,0,0-2.31.84,5.37,5.37,0,0,0-1.71,1.57,5.15,5.15,0,0,0-.76,4.23c.4,1.39.86,2.76,1.26,4.05l3.84,12.26c.44,1.42.78,2.54,1,3.34.11.36.19.65.26.87a1.14,1.14,0,0,1,.06.31l-.11-.29L287,301c-.26-.79-.64-1.9-1.11-3.31-1-2.92-2.32-7.08-4-12.21-.41-1.3-.87-2.62-1.3-4.06a5.56,5.56,0,0,1,.8-4.58,5.77,5.77,0,0,1,1.84-1.7,13.59,13.59,0,0,1,2.39-.9l5-1.61,10.71-3.45,2.81-.9a6.27,6.27,0,0,1,3.05-.42,5.68,5.68,0,0,1,4.69,3.88l3.68,11.51c.59,1.86,1.18,3.68,1.75,5.47.28.9.57,1.78.84,2.65a7.26,7.26,0,0,1,.53,2.74,5.63,5.63,0,0,1-2.6,4.56,9.21,9.21,0,0,1-2.38,1l-2.31.74-8.46,2.68-7,2.19A14,14,0,0,1,293,306a5.58,5.58,0,0,1-2.52-.41,5.37,5.37,0,0,1-2.61-2.31A4,4,0,0,1,287.42,302.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.09,276.32a1.57,1.57,0,0,1,.14.32c.09.27.21.6.35,1,.32,1,.76,2.24,1.3,3.85,1.13,3.42,2.69,8.16,4.53,13.76l.08.22-.23.08-13.56,4.37-.33-.17h0v-.06l0-.08-.05-.17-.11-.33-.21-.67-.42-1.31-.83-2.59-1.58-5-2.79-8.84-.07-.2.2-.06,10-3.08,2.73-.82a7.69,7.69,0,0,1,.93-.25,9,9,0,0,1-1,.37l-2.74.93-9.78,3.25.14-.26c.86,2.65,1.83,5.62,2.86,8.81.52,1.6,1.05,3.26,1.6,5,.28.85.55,1.71.83,2.58.14.44.28.87.43,1.32l.21.66.1.33.06.17,0,.08,0,0v0h0l-.33-.17,13.58-4.32-.16.29-4.26-13.68c-.5-1.65-.9-3-1.2-3.94-.12-.43-.23-.78-.31-1.07S304.09,276.33,304.09,276.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,288.61a6.6,6.6,0,0,1,.93.46l2.45,1.34c2.09,1.14,5,2.77,8.46,4.72l-.34.27c-.93-2.86-2-6.09-3.08-9.49l-3-9.52.44,0c-1.66,3.58-3.1,6.61-4.13,8.76-.5,1-.91,1.86-1.22,2.51a6.65,6.65,0,0,1-.49.92,6.61,6.61,0,0,1,.34-.88c.28-.65.64-1.5,1.09-2.52.94-2.18,2.31-5.3,4-9l.25-.55.19.58,3.07,9.5,3,9.51.19.58-.53-.3c-3.5-2-6.43-3.78-8.46-5l-2.35-1.42A8.15,8.15,0,0,1,298.47,288.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,285.2a26.85,26.85,0,0,1-4.86-2,26.58,26.58,0,0,1-4.64-2.5,26.85,26.85,0,0,1,4.86,2A26.12,26.12,0,0,1,300,285.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.62,299.68A27.47,27.47,0,0,1,299,295a26.75,26.75,0,0,1,2.78-4.48,27.47,27.47,0,0,1-2.33,4.73A26.24,26.24,0,0,1,296.62,299.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.29,276.34s.14.4.55,1.08a5.41,5.41,0,0,0,2.59,2.17,5.22,5.22,0,0,0,2.42.35,14.16,14.16,0,0,0,2.86-.78l7-2.28,8.44-2.73,2.31-.75a9.65,9.65,0,0,0,2.27-.92,5.2,5.2,0,0,0,2.37-4.19,6.87,6.87,0,0,0-.52-2.58l-.85-2.65c-.58-1.78-1.16-3.61-1.76-5.47-1.19-3.71-2.43-7.56-3.69-11.5a5.16,5.16,0,0,0-4.26-3.53,5.9,5.9,0,0,0-2.83.4l-2.81.9-10.72,3.42-5,1.59a13.34,13.34,0,0,0-2.31.84,5.37,5.37,0,0,0-1.71,1.57,5.15,5.15,0,0,0-.77,4.23c.41,1.39.86,2.76,1.26,4.05L368,271.82c.43,1.42.77,2.54,1,3.34.1.36.19.65.25.87a1.58,1.58,0,0,1,.07.31,1.48,1.48,0,0,1-.12-.29c-.08-.22-.18-.5-.3-.86l-1.12-3.31c-.95-2.92-2.32-7.08-4-12.21-.41-1.3-.87-2.62-1.3-4.06a5.63,5.63,0,0,1,.8-4.58,5.7,5.7,0,0,1,1.85-1.7,13.3,13.3,0,0,1,2.39-.9l5-1.61,10.72-3.45,2.81-.9a6.25,6.25,0,0,1,3.05-.42,5.66,5.66,0,0,1,4.68,3.88l3.69,11.51,1.74,5.47c.29.89.57,1.78.85,2.65a7.07,7.07,0,0,1,.52,2.74,5.58,5.58,0,0,1-2.6,4.56,9.15,9.15,0,0,1-2.37,1l-2.32.74-8.46,2.67-7,2.2a14.25,14.25,0,0,1-2.93.76,5.6,5.6,0,0,1-2.52-.41,5.34,5.34,0,0,1-2.6-2.31A4,4,0,0,1,369.29,276.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,271.57a21.1,21.1,0,0,0,2.34-1.21A10.59,10.59,0,0,0,390,254.91a9.85,9.85,0,0,0-2.18-2.09,9.68,9.68,0,0,0-2.81-1.43,10.45,10.45,0,0,0-11.81,3.78,9.83,9.83,0,0,0-1.45,2.8,9.93,9.93,0,0,0-.56,3,10.6,10.6,0,0,0,1.23,5.4,10.44,10.44,0,0,0,3.22,3.64,10.74,10.74,0,0,0,6.72,2,24.77,24.77,0,0,0,2.61-.38,8.38,8.38,0,0,1-2.6.58,10.66,10.66,0,0,1-6.94-1.86,10.84,10.84,0,0,1-3.39-3.74,11,11,0,0,1-1.33-5.63,10.21,10.21,0,0,1,.57-3.11,10.48,10.48,0,0,1,1.5-2.94,10.95,10.95,0,0,1,12.4-4,10.43,10.43,0,0,1,2.93,1.51,10.06,10.06,0,0,1,2.26,2.2,10.93,10.93,0,0,1,2.19,5.36,10.79,10.79,0,0,1-5.14,10.56A8.48,8.48,0,0,1,385,271.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.5,272a5.52,5.52,0,0,1-1-2.17,5.75,5.75,0,0,1-.48-2.33,5.45,5.45,0,0,1,1,2.17A5.79,5.79,0,0,1,385.5,272Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.29,264.18a5.52,5.52,0,0,1,2.17-1,5.45,5.45,0,0,1,2.33-.47,5.68,5.68,0,0,1-2.17,1A5.6,5.6,0,0,1,371.29,264.18Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.3,259a5.68,5.68,0,0,1,2.17-1,5.57,5.57,0,0,1,2.33-.48,10.76,10.76,0,0,1-4.5,1.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,255.49a5.79,5.79,0,0,1-1-2.17,5.49,5.49,0,0,1-.47-2.33,5.52,5.52,0,0,1,1,2.17A5.45,5.45,0,0,1,380.21,255.49Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.6,264.39a30.86,30.86,0,0,1-7.13-3.67,30.86,30.86,0,0,1,7.13,3.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,265.26a5.88,5.88,0,0,1-1-2.19,5.64,5.64,0,0,1-.48-2.35,5.7,5.7,0,0,1,1,2.19A5.64,5.64,0,0,1,383,265.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.49,289.42s.14.4.54,1.08a5.44,5.44,0,0,0,2.6,2.17,5.2,5.2,0,0,0,2.42.35,13.69,13.69,0,0,0,2.86-.78l7-2.27,8.44-2.74,2.31-.75a9.4,9.4,0,0,0,2.26-.92,5.15,5.15,0,0,0,2.37-4.19,6.85,6.85,0,0,0-.51-2.58c-.28-.87-.57-1.75-.85-2.65-.58-1.78-1.17-3.61-1.76-5.46-1.2-3.72-2.43-7.57-3.7-11.51a5.17,5.17,0,0,0-4.25-3.53,5.9,5.9,0,0,0-2.83.4l-2.81.9-10.72,3.42-5,1.59a12.84,12.84,0,0,0-2.31.85,5.2,5.2,0,0,0-1.7,1.56,5.11,5.11,0,0,0-.77,4.23c.41,1.4.86,2.76,1.26,4.05,1.62,5.15,2.93,9.33,3.84,12.26.44,1.42.78,2.54,1,3.34l.26.87a1.58,1.58,0,0,1,.07.31,1.48,1.48,0,0,1-.12-.29l-.31-.86c-.26-.79-.63-1.9-1.11-3.31-.95-2.92-2.32-7.08-4-12.21-.41-1.29-.87-2.62-1.3-4.06a5.56,5.56,0,0,1,.8-4.58,5.77,5.77,0,0,1,1.84-1.7,13.59,13.59,0,0,1,2.39-.9l5-1.61,10.71-3.45,2.81-.9a6.31,6.31,0,0,1,3.06-.42,5.68,5.68,0,0,1,4.68,3.88l3.68,11.51q.9,2.79,1.75,5.47l.85,2.66a7.17,7.17,0,0,1,.52,2.73,5.61,5.61,0,0,1-2.6,4.56,9.29,9.29,0,0,1-2.37,1l-2.32.74L344,290.32l-7,2.19a13.64,13.64,0,0,1-2.93.76,5.47,5.47,0,0,1-2.52-.41,5.37,5.37,0,0,1-2.61-2.31A4.16,4.16,0,0,1,328.49,289.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,287.24a9.58,9.58,0,0,1,1-.37l2.78-.95,9.89-3.29-.14.27c-1.64-5.07-3.62-11.2-5.76-17.79l.33.16h-.06l-.05,0-.12,0-.23.07-.46.15-.92.29-1.82.58-3.52,1.13-6.56,2.08.15-.29c1.63,5.23,3,9.65,4,12.83.47,1.54.84,2.78,1.12,3.69.11.4.21.73.29,1l.09.36s-.05-.09-.13-.3-.19-.56-.33-.93l-1.22-3.6c-1.05-3.2-2.52-7.65-4.26-12.91l-.07-.22.22-.08,6.55-2.11L340,266l1.81-.58.92-.3.46-.15.23-.07.12,0,.05,0h.06l.33.17c2.1,6.61,4.05,12.74,5.67,17.82l.06.21-.2.06-10.08,3.12-2.77.83A7.79,7.79,0,0,1,335.72,287.24Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.3,270.15a7.6,7.6,0,0,1,.63,1.52c.35,1,.84,2.37,1.4,4l0,.13-.09.1-2.13,2.42-.3.33-.14-.43c-.17-.54-.35-1.11-.54-1.68-.9-2.81-1.69-5.37-2.24-7.25l-.1-.31.31.07c2,.5,3.23.92,3.16,1.06s-1.23-.29-3.24-.69l.22-.24c.64,1.85,1.49,4.39,2.39,7.2l.53,1.69-.43-.1,2.16-2.38-.05.23c-.51-1.69-.93-3.1-1.21-4.11A7,7,0,0,1,348.3,270.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,280.19c0-.05.39,0,1-.21a4.26,4.26,0,0,0,2.29-1.51,4.07,4.07,0,1,0-6.53-.18,4.27,4.27,0,0,0,2.2,1.64c.63.2,1,.21,1,.26a2.37,2.37,0,0,1-1.07-.07,4.19,4.19,0,0,1-2.44-1.61,4.46,4.46,0,0,1-.59-4.27,4.52,4.52,0,0,1,8.52.23,4.45,4.45,0,0,1-.82,4.23,4.26,4.26,0,0,1-2.52,1.48A2.28,2.28,0,0,1,339.66,280.19Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68,330.55a10.42,10.42,0,0,0,.54,1.08,5.41,5.41,0,0,0,2.59,2.18,5.26,5.26,0,0,0,2.43.35,13.76,13.76,0,0,0,2.86-.79l7-2.27,8.43-2.74,2.32-.74a9.4,9.4,0,0,0,2.26-.92,5.17,5.17,0,0,0,2.37-4.2,6.8,6.8,0,0,0-.51-2.57c-.28-.87-.57-1.75-.85-2.65q-.87-2.68-1.76-5.47c-1.2-3.71-2.43-7.56-3.7-11.5a5.16,5.16,0,0,0-4.25-3.53,5.9,5.9,0,0,0-2.83.4l-2.81.89L345,301.5l-5,1.59a13.64,13.64,0,0,0-2.31.84A5.37,5.37,0,0,0,336,305.5a5.15,5.15,0,0,0-.76,4.23c.4,1.39.86,2.76,1.26,4,1.61,5.15,2.93,9.33,3.84,12.26.44,1.42.78,2.54,1,3.34l.26.87c.05.2.07.3.07.3s-.05-.09-.12-.28l-.31-.86c-.26-.79-.64-1.9-1.11-3.31-1-2.92-2.32-7.08-4-12.21-.41-1.3-.87-2.62-1.3-4.06a5.55,5.55,0,0,1,.8-4.58,5.77,5.77,0,0,1,1.84-1.7,13.59,13.59,0,0,1,2.39-.9l5-1.61,10.71-3.45,2.81-.91a6.41,6.41,0,0,1,3.06-.41,5.68,5.68,0,0,1,4.68,3.88l3.68,11.51c.59,1.86,1.18,3.68,1.75,5.47.28.89.57,1.78.85,2.65a7.46,7.46,0,0,1,.52,2.74,5.63,5.63,0,0,1-2.6,4.56,9.21,9.21,0,0,1-2.38,1l-2.31.74-8.46,2.67-7,2.2a14.25,14.25,0,0,1-2.93.76,5.58,5.58,0,0,1-2.52-.41,5.37,5.37,0,0,1-2.61-2.31A3.75,3.75,0,0,1,341.68,330.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,322c0-.05.46-.19,1.19-.67a5.52,5.52,0,0,0,2.17-2.82,5.32,5.32,0,1,0-8.12,2.6,5.55,5.55,0,0,0,3.42,1c.86,0,1.33-.2,1.34-.15s-.1.06-.33.14a4.57,4.57,0,0,1-1,.21,5.56,5.56,0,0,1-3.64-.94,5.7,5.7,0,0,1-2.49-4.91,5.63,5.63,0,0,1,1.08-3.18,5.73,5.73,0,0,1,6.53-2.09,5.73,5.73,0,0,1,3.55,7.4,5.53,5.53,0,0,1-2.41,2.88,4.16,4.16,0,0,1-.94.41C355.12,322,355,322,355,322Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.15,314.32c0-.14.81-.53,1.9-.88s2-.53,2.06-.39-.8.53-1.9.88S360.19,314.46,360.15,314.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.86,322.45a5.76,5.76,0,0,1-2.15-1.05c-1.11-.71-1.95-1.38-1.87-1.5A5.69,5.69,0,0,1,362,321C363.1,321.66,363.94,322.33,363.86,322.45Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.15,309.56c-.13-.06.09-.83.48-1.72s.82-1.55,1-1.5-.08.82-.49,1.72S357.27,309.63,357.15,309.56Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.22,309.35c-.13,0-.52-.76-.86-1.8a4.18,4.18,0,0,1-.38-2c.14,0,.53.76.87,1.8S351.36,309.3,351.22,309.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,327.83a7,7,0,0,1-1.1-2.23,7.28,7.28,0,0,1-.77-2.37,5.36,5.36,0,0,1,1.25,2.18A5.47,5.47,0,0,1,357.29,327.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.55,326.08c-.13-.06.12-.81.56-1.66s.89-1.49,1-1.42-.12.81-.56,1.66S348.68,326.15,348.55,326.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,319.55c0-.14.71-.44,1.67-.68s1.75-.31,1.78-.17-.71.44-1.66.67S342.73,319.69,342.69,319.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.09,311c.07-.12.94.23,1.93.79s1.75,1.12,1.68,1.24-.93-.23-1.93-.79S343,311.1,343.09,311Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.48,317.47s.14.4.55,1.08a5.36,5.36,0,0,0,2.59,2.18,5.22,5.22,0,0,0,2.42.35,13.59,13.59,0,0,0,2.86-.79l7-2.27,8.44-2.74,2.31-.75a9,9,0,0,0,2.26-.91,5.15,5.15,0,0,0,2.37-4.2,6.61,6.61,0,0,0-.51-2.57c-.28-.87-.56-1.76-.85-2.65-.58-1.79-1.16-3.61-1.76-5.47-1.2-3.71-2.43-7.56-3.7-11.5a5.14,5.14,0,0,0-4.25-3.53,5.78,5.78,0,0,0-2.83.39l-2.81.9-10.72,3.42-5,1.59a14,14,0,0,0-2.31.85,5.31,5.31,0,0,0-1.7,1.56,5.16,5.16,0,0,0-.77,4.23c.41,1.4.86,2.77,1.26,4.06L381.14,313c.43,1.42.77,2.54,1,3.34.1.36.18.65.25.87a1.81,1.81,0,0,1,.07.3s-.05-.09-.12-.28l-.3-.86L380.94,313c-.95-2.92-2.32-7.08-4-12.21-.41-1.3-.87-2.63-1.3-4.07a5.56,5.56,0,0,1,.8-4.57,5.66,5.66,0,0,1,1.84-1.7,13.11,13.11,0,0,1,2.39-.9l5-1.61,10.71-3.45,2.82-.91a6.5,6.5,0,0,1,3.05-.42,5.69,5.69,0,0,1,4.68,3.89l3.68,11.51c.6,1.85,1.18,3.68,1.75,5.47.29.89.57,1.78.85,2.65a7.26,7.26,0,0,1,.52,2.74,5.58,5.58,0,0,1-2.6,4.56,9.15,9.15,0,0,1-2.37,1l-2.32.73L398,318.37l-7,2.2a14.25,14.25,0,0,1-2.93.76,5.6,5.6,0,0,1-2.52-.41,5.42,5.42,0,0,1-2.61-2.31A4.13,4.13,0,0,1,382.48,317.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.17,312a20.78,20.78,0,0,0,2.34-1.2,10.69,10.69,0,0,0,4.31-5.49,10.47,10.47,0,0,0-1.64-9.92,9.81,9.81,0,0,0-2.17-2.09,9.54,9.54,0,0,0-2.79-1.42,10.45,10.45,0,0,0-11.79,3.77,10,10,0,0,0-1.44,2.79,9.87,9.87,0,0,0-.56,3,10.61,10.61,0,0,0,11.14,11,23.68,23.68,0,0,0,2.6-.38,8.25,8.25,0,0,1-2.59.58,10.6,10.6,0,0,1-6.92-1.86,10.78,10.78,0,0,1-3.38-3.73,10.94,10.94,0,0,1-1.33-5.61,11.1,11.1,0,0,1,2.07-6,11.1,11.1,0,0,1,5.53-4,11,11,0,0,1,6.83.06,10.24,10.24,0,0,1,2.92,1.51,10,10,0,0,1,2.26,2.19,10.82,10.82,0,0,1,1.61,10.34,10.67,10.67,0,0,1-4.55,5.54A8.11,8.11,0,0,1,398.17,312Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,297.76c0-.05-.13.92-.44,2.63s-.76,4.19-1.35,7.08l-.09.42-.32-.29-3.61-3.3-3.66-3.38-.31-.29.4-.12c2.78-.88,5.18-1.58,6.83-2.05s2.59-.75,2.55-.7-.28.11-.74.28l-1.94.69c-1.65.58-3.9,1.38-6.55,2.24l.09-.41,3.68,3.36c1.27,1.17,2.48,2.28,3.59,3.32l-.4.13c.59-2.76,1.16-5.1,1.57-6.82.19-.79.36-1.46.49-2A7,7,0,0,1,399,297.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,344s.14.4.55,1.08a5.32,5.32,0,0,0,5,2.53,14.41,14.41,0,0,0,2.86-.79l7-2.27,8.43-2.74,2.32-.75a8.65,8.65,0,0,0,2.26-.92,5.16,5.16,0,0,0,2.37-4.19,6.76,6.76,0,0,0-.51-2.57l-.86-2.65q-.86-2.69-1.76-5.47-1.78-5.58-3.69-11.5a5.16,5.16,0,0,0-4.25-3.53,5.76,5.76,0,0,0-2.83.39l-2.81.9-10.73,3.42-5,1.59a13.65,13.65,0,0,0-2.31.85,5.2,5.2,0,0,0-2.48,5.79c.41,1.4.87,2.76,1.27,4.05l3.84,12.26c.44,1.43.78,2.55,1,3.35l.26.87a1.18,1.18,0,0,1,.06.3l-.12-.29c-.07-.22-.17-.5-.3-.85-.26-.79-.64-1.9-1.11-3.31-1-2.92-2.32-7.08-4-12.21-.42-1.3-.87-2.63-1.3-4.07a5.53,5.53,0,0,1,.8-4.57,5.69,5.69,0,0,1,1.84-1.71,13.54,13.54,0,0,1,2.39-.89l5-1.61L316,311l2.81-.91a6.51,6.51,0,0,1,3.05-.42,5.69,5.69,0,0,1,4.69,3.89l3.68,11.5c.59,1.86,1.18,3.69,1.75,5.48.28.89.57,1.78.84,2.65a7.26,7.26,0,0,1,.53,2.74,5.65,5.65,0,0,1-2.6,4.56,10,10,0,0,1-2.38,1l-2.31.73-8.46,2.68-7,2.2a14,14,0,0,1-2.92.76,5.44,5.44,0,0,1-2.52-.42,5.37,5.37,0,0,1-2.61-2.31A3.91,3.91,0,0,1,302.1,344Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,320.92s-.05.15-.15.4l-.43,1.1c-.37.94-.89,2.29-1.58,4l0,.07-.08,0-5.76,1.21.1-.36,4.45,3.85.09.08v.12c-.21,1.84-.43,3.8-.65,5.85l-.39-.25,5-3c.11,0-.24,0,.24,0h.05l0,0,.09,0,.17.08.34.15.68.31,1.35.62,2.63,1.21-.35.29c-.46-2-.89-3.92-1.3-5.74l0-.12.09-.09,4-4.31.13.35-5.85-.58H316l0-.07c-.88-1.59-1.54-2.87-2-3.77-.22-.42-.4-.76-.54-1l-.2-.38s.07.08.2.3.34.57.58,1c.51.85,1.29,2.13,2.25,3.78l-.12-.08,5.86.47.42,0-.29.32-3.95,4.35.05-.21c.43,1.81.87,3.73,1.33,5.72l.12.51-.47-.22-2.64-1.2-1.35-.61-.68-.31-.34-.16-.17-.08-.09,0,0,0h.2l-5.05,3-.44.26.06-.51c.24-2,.47-4,.69-5.84l.08.21L305,327.65l-.32-.28.41-.08,5.77-1.12-.11.09c.77-1.74,1.4-3.1,1.82-4,.19-.41.34-.75.47-1A2.15,2.15,0,0,1,313.18,320.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.12,262.79a6.23,6.23,0,1,1,4-7.83A6.23,6.23,0,0,1,444.12,262.79Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.94,259.28c-.87.28-1.75-.14-2.15-1.4a2.82,2.82,0,0,1,.07-2.08l.51.12a2.45,2.45,0,0,0-.09,1.81c.28.86.83,1.21,1.48,1s.89-.77.58-1.74l-.11-.37.39-.13,2.27.87-.85-2.67.47-.15,1.08,3.35-.38.12-2.33-.88C443.18,258.27,442.77,259,441.94,259.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,307.54a1.59,1.59,0,1,1,1-2A1.59,1.59,0,0,1,279,307.54Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,316a1.59,1.59,0,1,1,1-2A1.59,1.59,0,0,1,281.7,316Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,324.51a1.59,1.59,0,1,1,1-2A1.59,1.59,0,0,1,284.42,324.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.77,289.12a33.76,33.76,0,0,1-1.58-4.4,35.75,35.75,0,0,1-1.28-4.5,34.86,34.86,0,0,1,1.58,4.4A35.24,35.24,0,0,1,474.77,289.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.49,289.85a69.17,69.17,0,0,1-2.86-8.9,33.09,33.09,0,0,1,1.58,4.4A35.24,35.24,0,0,1,472.49,289.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.21,290.58a35.61,35.61,0,0,1-1.58-4.4,34.62,34.62,0,0,1-1.27-4.5,35.88,35.88,0,0,1,1.57,4.4A35.24,35.24,0,0,1,470.21,290.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.31,223s.1.25.26.69.4,1.15.66,1.88l-.11-.06,1.37-.45c.26-.08.48-.18.8-.25a.79.79,0,0,1,.83.48,9,9,0,0,1,.3.92.84.84,0,0,1-.57.91l-2,.65.09-.18.78,2.39-.19-.1,3-1,.76-.24c.22-.07.31-.23.43-.49l.71-1.37c.24-.45.46-.89.69-1.33l.33-.64a1.06,1.06,0,0,0,.21-.58.59.59,0,0,0-.25-.48c-.16-.1-.39-.21-.57-.31l-1.14-.59c-.73-.37-1.43-.78-2-1a1.74,1.74,0,0,0-.91.15l-.84.26-1.37.4-.88.26-.33.08s.08-.05.27-.12l.85-.3,1.36-.47.86-.29a1.94,1.94,0,0,1,1-.18c.71.28,1.34.65,2.1,1l1.14.59c.2.1.38.18.61.32a.9.9,0,0,1,.38.69,1.41,1.41,0,0,1-.24.74l-.33.64c-.22.44-.44.88-.68,1.33l-.7,1.37a1,1,0,0,1-.61.64l-.76.25-3,1-.15,0,0-.14c-.27-.83-.52-1.63-.77-2.4l0-.14.14,0,2-.63a.55.55,0,0,0,.4-.62c-.06-.26-.18-.6-.26-.86a.59.59,0,0,0-.58-.35c-.24.05-.52.16-.77.23l-1.38.42-.09,0,0-.08-.58-2A5.15,5.15,0,0,1,446.31,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.41,288.85a11.47,11.47,0,0,1-2.67-1.7,7.82,7.82,0,0,1-1.7-1.88,34.84,34.84,0,0,1-1.85-3.32s.63-30.57,1.75-35.62,18.73-17.62,18.73-17.62l-11.86-12.17a94.29,94.29,0,0,0-21.18,21.58c-5.64,8.27.49,46.74.5,46.78a90.27,90.27,0,0,0-1,9.92c0,4.67.38,4.68.93,4.59,1.46-.24.36-8.21,1.59-6.63s.21,9.9,1.73,9.59c2-.41.67-8.73.61-9.44s1-.82,1-.18c0,.93.54,10.67,2.49,10.29,1.07-.21.51-2.11.51-2.11s-1.15-9.08-.22-9.23,1.79,5.16,1.95,7,1.08,2.44,1.81,1.71c.5-.5.14-6.06-.06-7.84s-.85-6.68,1.43-4.53,4.84,2.95,5.68,2.69A1,1,0,0,0,342.41,288.85Z",
    style: {
      fill: "#b78876"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.4c7a58c2c3985605cb34016c81424f4c.svg";
export { ForwardRef as ReactComponent };